// As this component is only styles and no functionality,
// there's not much point in test coverage here
/* istanbul ignore file */
import { corners, media, typography } from "../../styles";
import { applyOpacity } from "../../styles/utils";
import styled from "styled-components";
export const Link = styled.a`
  ${typography.body}
  /*
   * Was --d-text — a text link that's the exact same colour as body copy
   * reads as plain underlined text, not as a distinct interactive element.
   * --d-accent is the brand's dedicated highlight colour (already used for
   * BookingInfo's occurrence count and BookingSummaryCard's top border), so
   * using it here gives links a genuinely distinctive, on-brand colour
   * instead of borrowing the neutral text token.
   */
  color: ${({
  theme
}) => theme.brand.cssVars["--d-accent"]};
  text-decoration: none;
  white-space: nowrap;
  border-bottom: 1px solid ${({
  theme
}) => theme.brand.cssVars["--d-accent"]};

  &:focus {
    border-bottom: 1px solid
      ${({
  theme
}) => applyOpacity(theme.brand.cssVars["--d-accent"], 0, false)};
    ${corners.s}
  }

  @media ${media.hoverable} {
    &:hover {
      cursor: pointer;
      background-color: ${({
  theme
}) => applyOpacity(theme.brand.cssVars["--d-accent"], 0.08, true, theme.brand.cssVars["--d-surface"])};
      border-bottom: 1px solid
        ${({
  theme
}) => applyOpacity(theme.brand.cssVars["--d-accent"], 0, false)};
      ${corners.s}
    }
  }

  &:focus {
    outline: 1px solid ${({
  theme
}) => theme.brand.cssVars["--d-accent"]};
  }
`;
export default Link;